import React, {useCallback, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {getTicker} from "../store/actions/tickerActions";
import {translateOptions} from '../config'

function Ticker() {

    // Импорт диспатчера
    const dispatch = useDispatch();

    // Подписка на изменение стейта тикера
    const ticker = useSelector(state => state.ticker);

    // Получение данных тикера
    useEffect(() => {
        dispatch(getTicker());
    }, []);


    function SetTicker() {

        function setNumber(number,count) {
            if (number === null) {
                return ''
            }

            return number.toFixed(count)
        }

        let changeClass = 'account-table__cell-value account-table__cell-value--green'

        if (+ticker.priceChangePercent < 0) {
            changeClass = 'account-table__cell-value account-table__cell-value--red'
        }


        return <div className="account-header__ticker">

            <div className="account-table">
                <div className="account-table__row account-table__row--1-col">
                    <div className="account-table__cell account-table__cell--fill">
                        <div className="account-table__cell-name account-table__cell-name--center account-table__cell-name--fill">{translateOptions.tickerName}</div>
                    </div>
                </div>
                <div className="account-table__row account-table__row--2-col">
                    <div className="account-table__cell">
                        <div className="account-table__cell-name">24h</div>
                        <div className={changeClass}>{setNumber(+ticker.priceChangePercent,2)}%</div>
                    </div>
                    <div className="account-table__cell">
                        <div className="account-table__cell-name">O24h</div>
                        <div className="account-table__cell-value">{setNumber(+ticker.volume,2)}</div>
                    </div>
                </div>
                <div className="account-table__row account-table__row--2-col">
                    <div className="account-table__cell">
                        <div className="account-table__cell-name">{translateOptions.tickerSell}</div>
                        <div className="account-table__cell-value account-table__cell-value--red">{setNumber(+ticker.askPrice,2)}</div>
                    </div>
                    <div className="account-table__cell">
                        <div className="account-table__cell-name">{translateOptions.tickerMax}</div>
                        <div className="account-table__cell-value">{setNumber(+ticker.highPrice,2)}</div>
                    </div>
                </div>
                <div className="account-table__row account-table__row--2-col">
                    <div className="account-table__cell">
                        <div className="account-table__cell-name">{translateOptions.tickerBuy}</div>
                        <div className="account-table__cell-value account-table__cell-value--green">{setNumber(+ticker.bidPrice,2)}</div>
                    </div>
                    <div className="account-table__cell">
                        <div className="account-table__cell-name">{translateOptions.tickerMin}</div>
                        <div className="account-table__cell-value">{setNumber(+ticker.lowPrice,2)}</div>
                    </div>
                </div>
            </div>
        </div>;
    }

    return <SetTicker/>;
}

export default Ticker;
